interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizeMap = {
  sm: { top: "text-[10px]", bottom: "text-base", gap: "gap-0", tracking: "tracking-[0.2em]" },
  md: { top: "text-xs", bottom: "text-xl", gap: "gap-0", tracking: "tracking-[0.2em]" },
  lg: { top: "text-sm", bottom: "text-3xl", gap: "gap-0.5", tracking: "tracking-[0.25em]" },
  xl: { top: "text-base", bottom: "text-5xl", gap: "gap-1", tracking: "tracking-[0.25em]" },
};

export const Logo = ({ size = "md", className = "" }: LogoProps) => {
  const sizes = sizeMap[size];
  
  return (
    <div className={`flex flex-col ${sizes.gap} ${className}`}>
      <span className={`font-serif ${sizes.top} ${sizes.tracking} text-foreground/70 font-normal uppercase`}>
        Nordic Art
      </span>
      <span className={`font-serif ${sizes.bottom} italic text-foreground font-normal -mt-1`}>
        Collective
      </span>
    </div>
  );
};
